import { NotifyUpdateToastStyle } from '@styles/common/toastStyle';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import React from 'react';
import { IconReload } from '@tabler/icons-react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const NotifyUpdateToast = () => {
  const {
    t,
    ready
  } = useTranslation(['toast']);
  const router = useRouter();
  return /*#__PURE__*/_jsxs(NotifyUpdateToastStyle, {
    onClick: () => router.reload(),
    children: [ready ? t('toast:noticeOfUpdate') : '', /*#__PURE__*/_jsx(IconReload, {
      size: 16,
      color: "var(--gray-10)"
    })]
  });
};
export default NotifyUpdateToast;